import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GoogleCustomer } from '../Model/googlecustomer';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  checkLogin: string;

  constructor(
    private http: HttpClient,
  ) { }

  getProfiledetails(url: string, email: string, currentUrl: string) {
    return this.http.get<any>(url + "/" + email + "/" + currentUrl, { responseType: "json" });
  }

  setCheckLoggedIn(checkLogin: string) {
    this.checkLogin = checkLogin;
    localStorage.setItem("check-login", this.checkLogin);
  }

  validateCustomer(url: string, email: string, mobileNo: string) {
    return this.http.get(url + "/" + email + "/" + mobileNo, {
      responseType: "json",
    });
  }

  onGoogleSetUp(url: string, req: GoogleCustomer) {
    return this.http.post(url, req, { responseType: "json" });
  }

  getCCAvenueDecrptData(url: string, data: string, orderid: string, currentUrl: string) {
    return this.http.get(url + "/" + orderid + "/" + data + "/" + currentUrl, {
      responseType: "text",
    });
  }

  getCCAvenueCred(url: string, order_id: string, amount: string, currentUrl: string) {
    const fullUrl = `${url}/${order_id}/${amount}/${currentUrl}`;
    return this.http.get(fullUrl, {
      responseType: 'text'
    });
  }
}